import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetPatientItemsDocument,
  GetPatientItemsQueryVariables,
  SortEnumType,
} from '../../types/api/graphql';
import { AllPracticesId } from '../types';

export function usePatientItems(variables: GetPatientItemsQueryVariables) {
  const { data: patientItemsData, loading: patientItemsLoading } =
    useCacheQuery(GetPatientItemsDocument, {
      variables: {
        ...variables,
        healthProviderId:
          variables.healthProviderId !== AllPracticesId
            ? variables.healthProviderId
            : null,
        sort: variables.sort ?? [
          { firstName: SortEnumType.Asc },
          { lastName: SortEnumType.Asc },
        ],
      },
      skip: !variables.healthProviderId || !variables.group,
    });

  // Subscriptions

  const data = useMemo(() => {
    if (patientItemsData?.patients) {
      return {
        ...patientItemsData.patients,
        items: patientItemsData.patients.items ?? [],
      };
    }

    return null;
  }, [patientItemsData?.patients]);

  return {
    data,
    loading: patientItemsLoading,
  };
}
